import { map, filter } from 'rxjs/operators'
import * as actionTypes from '../../../constants/actionTypes'
import { afterAllTypes } from '../../../../lib/observables'
import { isPresenter } from '../../../../lib/username/username'
import { StateObservable } from 'redux-observable'
import { State } from '../../../reducers/reducerType'
import { setupTypes } from '../../../actions/setup/setupTypes'
import selectHasGigEnded from '../../../selectors/selectHasGigEnded'
import { addLocalTracks } from '../../../actions/tracks/trackActions'

/**
 * This epic listens out for the local Room listeners to have been set and for the presenter to have selected to enter the screen from the Preview page.
 * It then dispatches a request for a video track to be created and published as well as an audio track if the participant isn't dialed-in already too.
 */
const addLocalTracks$ = (actions$, state$: StateObservable<State>) => actions$.pipe(
  afterAllTypes(actionTypes.SET_LOCAL_ROOM_LISTENERS, setupTypes.SET_PRESENTER_TRACKS),
  filter(() => typeof state$.value.config.username === 'string' && isPresenter(state$.value.config.username) && !selectHasGigEnded(state$.value)),
  map(() => addLocalTracks())
)

export default addLocalTracks$
